import * as React from 'react';

import {useInterval} from 'shells/utils/hooks/use-interval';

type Props = {
    // Expected in format like 'America/Los_Angeles'
    timezone: string;
    /**
     * If provided, the current time in the given "timezone" will be compared to the time in the "currentUserTimezone"
     * and if they are different, the date will be included in the output.
     */
    currentUserTimezone?: string | null | undefined;
};

export function CurrentTimeInZone(props: Props) {
    const {currentUserTimezone} = props;

    const [date, setDate] = React.useState(new Date());

    useInterval(() => {
        setDate(new Date());
    }, 1000);

    // @ts-expect-error
    function getCurrentTimeInZone(timeZone) {
        const timeZoneName = new Intl.DateTimeFormat(undefined, {
            timeZoneName: 'long',
            timeZone,
        })
            .format(date)
            .split(',')[1];

        const [currentWeekday, currentDate, currentTime] = new Intl.DateTimeFormat(undefined, {
            hour: 'numeric',
            minute: 'numeric',
            hour12: true,
            weekday: 'short',
            month: 'numeric',
            day: 'numeric',
            timeZone,
        })
            .format(date)
            .split(', ');

        let includeDate;
        if (currentUserTimezone) {
            const currentUserDate = new Intl.DateTimeFormat(undefined, {
                hour: 'numeric',
                minute: 'numeric',
                hour12: true,
                weekday: 'short',
                month: 'numeric',
                day: 'numeric',
                // @ts-expect-error
                currentUserTimezone,
            })
                .format(date)
                .split(', ')[1];

            includeDate = currentDate !== currentUserDate;
        }

        return (
            <>
                {timeZoneName} ({currentTime}
                {includeDate && (
                    <i>
                        {' '}
                        - {currentWeekday}, {currentDate}
                    </i>
                )}
                )
            </>
        );
    }

    return <div>{getCurrentTimeInZone(props.timezone)}</div>;
}
